var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.value),expression:"value"}],staticClass:"en-tips"},[_c('div',{staticClass:"tips-container"},[_vm._v(" "+_vm._s(_vm.tips)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }